<template>
  <div
    class="flex w-fit items-center justify-center rounded-sm"
    :class="[
      theme === 'dark' ? 'bg-gray-90' : 'bg-gray-70',
      size === 'large' ? 'h-8 min-w-8 px-2' : 'h-5 min-w-5 px-1',
    ]"
  >
    <span class="text-xs font-semibold text-white">{{ keyboardKey }}</span>
  </div>
</template>

<script setup lang="ts">
export type KeySize = 'large' | 'small'
export type KeyTheme = 'dark' | 'light'

withDefaults(
  defineProps<{
    keyboardKey: string
    size?: 'large' | 'small'
    theme?: 'dark' | 'light'
  }>(),
  {
    size: 'large',
    theme: 'dark',
  },
)
</script>
